module.exports = __webpack_public_path__ + "static/media/banner-phone-AcrossCountry.871ef84d.jpg";